import formats from '../fr/formats';

export default {
  // Formats i18n.js
  ...formats,
  // Overwrite fr (standard)
  number: {
    currency: {
      format: {
        delimiter: ',',
        format: '%u %n',
        precision: 2,
        separator: '.',
        significant: false,
        strip_insignificant_zeros: false,
        unit: 'Rs',
      },
    },
    percentage: {
      format: {
        delimiter: '',
        format: '%n%',
      },
    },
    format: {
      delimiter: ',',
      precision: 2,
      separator: '.',
      significant: false,
      strip_insignificant_zeros: false,
    },
  },
};
